import { useState } from "react";
import { useStore } from "../state/store";

const COMMON_LOCALES: { code: string; label: string }[] = [
  { code: "en_US", label: "English (US)" },
  { code: "en_GB", label: "English (UK)" },
  { code: "es_ES", label: "Spanish (Spain)" },
  { code: "es_MX", label: "Spanish (Mexico)" },
  { code: "de_DE", label: "German" },
  { code: "fr_FR", label: "French" },
  { code: "fr_CA", label: "French (Canada)" },
  { code: "pt_BR", label: "Portuguese (Brazil)" },
  { code: "ru_RU", label: "Russian" },
  { code: "ja_JP", label: "Japanese" },
  { code: "ko_KR", label: "Korean" },
  { code: "zh_CN", label: "Chinese (Simplified)" },
  { code: "zh_TW", label: "Chinese (Traditional)" },
];

export function LanguagesPanel() {
  const languages = useStore((s) => s.project.languages);
  const addLanguage = useStore((s) => s.addLanguage);
  const removeLanguage = useStore((s) => s.removeLanguage);

  const [pick, setPick] = useState(COMMON_LOCALES[0].code);
  const available = COMMON_LOCALES.filter((l) => !languages.some((x) => x.code === l.code));

  return (
    <div className="panel">
      <h2>Languages</h2>
      <p className="hint">
        Each language produces a <code>texts/&lt;code&gt;.lang</code> file. Display names and guide text are edited per
        language in the Items and Guide panels.
      </p>

      <section className="card">
        <ul className="entity-list">
          {languages.map((l) => (
            <li key={l.code}>
              <span className="entity-name">{l.label}</span>
              <code>{l.code}</code>
              <button
                className="btn danger"
                disabled={languages.length <= 1}
                onClick={() => removeLanguage(l.code)}
                title={languages.length <= 1 ? "At least one language is required" : "Remove"}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      </section>

      <section className="card">
        <h3>Add a language</h3>
        <div className="btn-row">
          <select value={pick} onChange={(e) => setPick(e.target.value)}>
            {available.map((l) => (
              <option key={l.code} value={l.code}>
                {l.label} ({l.code})
              </option>
            ))}
          </select>
          <button
            className="btn primary"
            disabled={available.length === 0}
            onClick={() => {
              const found = COMMON_LOCALES.find((l) => l.code === pick);
              if (found) addLanguage(found);
            }}
          >
            Add
          </button>
        </div>
      </section>
    </div>
  );
}
